import { useMutation } from "@tanstack/react-query";
import { GET, POST } from "../../../../services/index";

// สรุป KPI รายคน ต่อเดือน
export const useFetchKpiReport = () => {
  return useMutation({
    mutationFn: async ({ month }) => {
      const { result } = await GET(`/api/v1/kpiReport/monthly?month=${month}`);
      return result;
    },
  });
};

// หัวหน้าให้คะแนนจิตพิสัย (เต็ม 1)
export const useSaveAttitude = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/kpiReport/attitude`, payload),
  });
};
